import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ConfirmModal } from '../../../components/ConfirmModal';
import { getImgSrc, getPlatformImg } from '../../../helpers/getImgSrc';
import LoadingSpinner from '../../../components/client/LoadingSpinner';
import { getAccountStatus, getExternalCampaigns, getUserCampaignList, getPlatformList, listCampaignAds, updateCampaignAssociateStatus } from '../../../services/ApiService';
import { getPlatformName, getPlatformNameOrId } from '../../../helpers/getPlatformName';
import { toast } from 'react-toastify';
import './link_campaign.css'
import { useSelector } from 'react-redux';
import { handleApi } from '../../../utils/authentication';
import { Link } from 'react-router-dom';


const LinkCampaigns = () => {
  const [platforms, setPlatforms] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [uiCampaigns, setUICampaigns] = useState([]);
  const [programs, setPrograms] = useState([])
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedUiProgram, setSelectedUiProgram] = useState(null);
  const [selectedUiCampaign, setSelectedUiCampaign] = useState(null);
  const [platformList, setPlatformList] = useState([]);
  const [campaignAds, setCampaignAds] = useState([]);
  const [selectedAd, setSelectedAd] = useState(null);
  const filter = useSelector((state) => state?.filter)
  const user = useSelector((state) => state?.user)





  const [loading, setLoading] = useState({
    platform: true,
    campaigns: true,
    uiPrograms: true,
    uiCampaigns: true,
    linkAction: false,
    campaignAds: false
  });

  const [linkActionConfirmModal, setLinkActionConfirmModal] = useState(false);

  const fetchPlatformsList = async () => {
    try {
      let result = await getPlatformList()
      if (result?.success) {
        setPlatformList(result?.data?.platforms)

      }

    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    const fetchPlatforms = async () => {
      setLoading(prev => ({ ...prev, platform: true }));
      const accStatus = await getAccountStatus();
      if (accStatus.success) {
        setPlatforms(Object.values(accStatus.platforms));
      }
      setLoading(prev => ({ ...prev, platform: false }));
    };
    fetchPlatforms();
    fetchPlatformsList()
  }, []);

  useEffect(() => {
    if (selectedPlatform) {
      const loadCampaigns = async () => {
        setLoading(prev => ({ ...prev, campaigns: true }));
        try {
          const campaignsData = await getExternalCampaigns(selectedPlatform.platform_id);
          setCampaigns(campaignsData.success ? campaignsData.campaigns : []);
        } catch (error) {
          setCampaigns([]);
        } finally {
          setLoading(prev => ({ ...prev, campaigns: false }));
        }
      };
      loadCampaigns();
    }
  }, [selectedPlatform]);



  const loadCampaignsAds = async () => {
    setLoading(prev => ({ ...prev, campaignAds: true }));
    try {
      const campaignAds = await listCampaignAds(selectedPlatform.platform_id, selectedCampaign.external_campaign_id);
      setCampaignAds(campaignAds.success ? campaignAds.data.ads_list : []);
    } catch (error) {
      setCampaignAds([]);
    } finally {
      setLoading(prev => ({ ...prev, campaignAds: false }));
    }
  };

  useEffect(() => {
    if (selectedCampaign) {
      loadCampaignsAds();
    }
  }, [selectedCampaign]);

  const loadUIPrograms = async () => {
    try {
      //console.log("loadUIPrograms called")
      //fetch programs list
      let formData = new FormData();
      formData.append('client_id', user?.client_id)
      formData.append('role_id', user?.role_id)
      let result = await handleApi('program_list', 'POST', {}, formData)
      // console.log(result)
      if (result?.data?.programs_list.length > 0) {
        setPrograms(result?.data?.programs_list)

      }

    } catch (e) {
      console.log(e)
    }
  }
  useEffect(() => {
    loadUIPrograms()

  }, [selectedAd])

  const loadUICampaigns = async () => {
    setLoading(prev => ({ ...prev, uiCampaigns: true }));
    try {
      const uiCampaignsData = await getUserCampaignList(
        selectedPlatform.platform_id,
        selectedCampaign.external_campaign_id,
        selectedAd.id,
        selectedUiProgram?.program_id
      );
      setUICampaigns(uiCampaignsData.success ? uiCampaignsData.data.campaigns_list : []);
    } catch (error) {
      setUICampaigns([]);
    } finally {
      setLoading(prev => ({ ...prev, uiCampaigns: false }));
    }
  };
  useEffect(() => {
    if (selectedCampaign) {
      loadUICampaigns();
    }
  }, [selectedCampaign, selectedPlatform, selectedAd, selectedUiProgram]);

  const handlePlatformSelect = () => {

    if (filter?.filter_ads_selected_platform) {
      setSelectedPlatform(filter?.filter_ads_selected_platform?.accountDetails);
      setSelectedCampaign(null);
      setSelectedUiCampaign(null);

    }

  };

  const handleCampaignSelect = (campaign) => {
    setSelectedCampaign(campaign);
    setSelectedAd(null)
    setSelectedUiCampaign(null);
  };

  const handleAdSelect = (ad) => {
    setSelectedAd(ad);
    setSelectedUiCampaign(null);
    setSelectedUiProgram(null)
  };

  const handleProgramSelect = (program) => {
    setSelectedUiProgram(program)
    setSelectedUiCampaign(null);

  }

  const handleLinkOrUnlinkUICampaign = async () => {
    setLoading(prev => ({ ...prev, linkAction: true }));
    try {
      const formData = new FormData();
      formData.append('campaign_id', selectedUiCampaign.campaign_id);
      formData.append('platform_id', selectedPlatform.platform_id);
      formData.append('is_mapped', selectedUiCampaign.is_mapped);
      formData.append('external_campaign_id', selectedCampaign.external_campaign_id);
      formData.append('ads_id', selectedAd.id);
      formData.append('client_id', user?.client_id);

      const result = await updateCampaignAssociateStatus(formData);
      if (result?.success) {
        loadUICampaigns()
        setSelectedPlatform((prev) => {
          const currentCount = prev?.total_ads_linked || 0;

          if (selectedUiCampaign?.is_mapped && currentCount > 0) {
            return { ...prev, total_ads_linked: currentCount - 1 };
          } else if (!selectedUiCampaign?.is_mapped) {
            return { ...prev, total_ads_linked: currentCount + 1 };
          }

          return prev;
        });
        toast.success(result.message);
      } else {
        
        if(result?.error?.error_message){
          toast.error(result?.error?.error_message);
        }else{
          toast.error('This ad is already linked to another campaign');
        }
      }
    } catch (error) {


      toast.error(error?.error_message || 'This ad is already linked to another campaign');
    } finally {
      setLinkActionConfirmModal(false);
      setLoading(prev => ({ ...prev, linkAction: false }));
    }
  };

  useEffect(() => {
    handlePlatformSelect()
  }, [filter?.filter_ads_selected_platform])



  return (
    <div className="d-flex flex-column">
      {/* platform header */}
      <div className='w-100 bg-white custom_border custom-card link_campaigns_header'>
        <div className='link_campaigns_header_platform_container '>
          <div className='link_campaigns_header_logo'>
            <img src={getPlatformImg(selectedPlatform?.platform_id)} alt="" />
          </div>
          <div className='link_campaigns_header_platform'>
            <h4>{getPlatformName(selectedPlatform?.platform_id)}</h4>
            {selectedPlatform?.is_account_linked &&
              <div className='link_campaigns_header_platform_badge'>
                <div className='link_campaigns_header_platform_badge_dot'></div>
                <p>Connected</p>
              </div>}
          </div>
        </div>

        <div className='link_campaigns_header_user_details_container'>
          <div className='row g-3'>
            <div className='col-md-6'>
              <p className='user_details_container_heading'>Connected As</p>
              <p className='user_details_container_data'>{selectedPlatform?.account_details?.account_name}</p>

            </div>
            <div className='col-md-6'>
              <p className='user_details_container_heading'>Connected On</p>
              <p className='user_details_container_heading text_dark'>{selectedPlatform?.account_details?.created_at}</p>

            </div>
            <div className='col-md-6'>
              <p className='user_details_container_heading'>Linked {selectedPlatform?.total_ads_linked}   {(selectedPlatform?.account_details?.media_type === "paid_media" || selectedPlatform?.account_details?.media_type === "paid_social") ? "Ads" : "Ads"}

              </p>
              <p className='user_details_container_data'>
                {(selectedPlatform?.account_details?.media_type === "paid_media" || selectedPlatform?.account_details?.media_type === "paid_social") ? "ADS" : "ADS"}
              </p>

            </div>


          </div>



        </div>


      </div>



      <div className="row">
        <div className="col-12">
          <div className="d-flex " style={{ minHeight: '80vh', maxHeight: '80vh' }}>



            {/* Column 1: Social Media Platforms */}
            {/* <div className={`col-md-${selectedPlatform ? '2' : '12'} col-12 pe-3 ${selectedPlatform && 'border_end'} overflow-y-auto position-relative`}>
              {loading.platform ? (
                <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" style={{ minHeight: '100%' }}>
                  <LoadingSpinner />
                </div>
              ) : (
                <div>
                  <h5>Platforms</h5>
                  <ul className="p-0 mt-5 border_top">
                    {platforms.map(platform => (
                      platform?.is_account_linked && platform?.platform_id != platformList['Google Analytics'] &&
                      <li
                        key={platform.platform_id}
                        className={`border_bottom p-3 ${selectedPlatform?.platform_id === platform.platform_id ? 'text_primary bg_primary_light' : ''}`}
                        onClick={() => handlePlatformSelect(platform)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="w-100 d-flex align-items-center gap-2 flex-start">
                          <img src={getPlatformImg(platform.platform_id)} className="img-fluid social_media_img" alt="" />
                          <span className="small">{getPlatformName(platform.platform_id)}</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div> */}

            {/* Column 2: Campaigns */}
            {selectedPlatform && (
              <div className={`col-md-${selectedCampaign ? '3' : '12'} col-12 px-3 ${selectedCampaign && 'border_end'} overflow-y-auto position-relative`}>
                {loading.campaigns ? (
                  <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" style={{ minHeight: '100%' }}>
                    <LoadingSpinner />
                  </div>
                ) : (
                  <div>
                    <h5>Campaigns</h5>
                    <span className="small">{`Campaigns under ${getPlatformName(selectedPlatform?.platform_id)}`}</span>
                    {campaigns.length > 0 ? (
                      <ul className="p-0 mt-3 border_top">
                        {campaigns.map(campaign => (
                          <li
                            key={campaign.external_campaign_id}
                            className={`border_bottom p-3 ${selectedCampaign?.external_campaign_id === campaign.external_campaign_id ? 'text_primary bg_primary_light' : ''}`}
                            onClick={() => handleCampaignSelect(campaign)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="w-100 text-start small">{campaign.campaign_name}</div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>No campaigns available. <span ><Link to="/client/settings/integrations" style={{ textDecoration: 'none' }}>Integrate Campaign</Link></span></p>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Column 3: Campaign Ads */}
            {selectedCampaign && (
              <div className={`col-md-${selectedAd ? '3' : '9'} col-12 px-3 ${selectedAd && 'border_end'} overflow-y-auto position-relative`}>
                {loading.campaignAds ? (
                  <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" style={{ minHeight: '100%' }}>
                    <LoadingSpinner />
                  </div>
                ) : (
                  <div>
                    <h5>Campaign Ads</h5>
                    <span className="small">{`Ads under ${selectedCampaign.campaign_name}`}</span>
                    {campaignAds.length > 0 ? (
                      <ul className="p-0 mt-3 border_top">
                        {campaignAds.map(ad => (
                          <li
                            key={ad.id}
                            className={`border_bottom p-3 ${selectedAd?.id === ad.id ? 'text_primary bg_primary_light' : ''}`}
                            onClick={() => handleAdSelect(ad)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="w-100 text-start small">{ad.name}</div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>No ads available.  <span ><Link to="/client/settings/integrations" style={{ textDecoration: 'none' }}>Click here to link ads</Link></span></p>
                    )}
                  </div>
                )}
              </div>
            )}
            {/* Column 3: Internal program list */}
            {selectedAd && (
              <div className={`col-md-${selectedAd ? '3' : '9'} col-12 px-3 ${selectedAd && 'border_end'} overflow-y-auto position-relative`}>
                {loading.campaignAds ? (
                  <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" style={{ minHeight: '100%' }}>
                    <LoadingSpinner />
                  </div>
                ) : (
                  <div>
                    <h5>Programs</h5>
                    <span className="small">Programs created under UI Platform</span>
                    {programs.length > 0 ? (
                      <ul className="p-0 mt-3 border_top">
                        {programs.map(program => (
                          <li
                            key={program.program_id}
                            className={`border_bottom p-3 ${selectedUiProgram?.program_id === program.program_id ? 'text_primary bg_primary_light' : ''}`}
                            onClick={() => handleProgramSelect(program)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="w-100 text-start small">{program.program_name}</div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>No Programs available.  <span ><Link to="/client/programs" style={{ textDecoration: 'none' }}>Create Program</Link></span></p>
                    )}

                  </div>
                )}
              </div>
            )}

            {/* Column 4: UI Campaigns */}
            {selectedUiProgram && (
              <div className="col-md-3 col-12 px-3 overflow-y-auto position-relative">
                {loading.uiCampaigns ? (
                  <div className="d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle" style={{ minHeight: '100%' }}>
                    <LoadingSpinner />
                  </div>
                ) : (
                  <div>
                    <h5>Campaigns present under UI Platform</h5>
                    <span className="small">You can link only one internal campaign to an external campaign</span>

                    {/* Table Header Section */}
                    <div className="mt-3 border_top ">
                      {/* <div className="d-flex justify-content-between align-items-center border_bottom py-3 bg-light">
                        <div className="col-md-5">
                          <span className="small">Program Name</span>
                        </div>
                        <div className="col-md-5">
                          <span className="small">Campaign Name</span>
                        </div>
                        <div className="col-md-2 d-flex align-items-center justify-content-end">
                          <span className="small">Action</span>
                        </div>
                      </div> */}

                      {/* List of UI Campaigns */}
                      {uiCampaigns.length > 0 ? (
                        <ul className="p-0 ">
                          {uiCampaigns.map(uiCampaign => (
                            <li
                              key={uiCampaign.campaign_id}
                              className={`d-flex justify-content-between align-items-center border_bottom py-3 }`}
                            >

                              <div className="col-md-10 d-flex flex-column gap-1">
                                <span className="small">{uiCampaign.campaign_name}</span>
                                <span className="small text_color_tertiary">{uiCampaign.program_name}</span>
                              </div>
                              <div className="col-md-2 d-flex align-items-center justify-content-end gap-2">
                                {uiCampaign.is_mapped ? <span ><Link to={`/client/campaigns/view-more/${selectedAd?.id}/${selectedPlatform?.platform_id}`} style={{ textDecoration: 'none',textWrapMode:'nowrap' }}>View Details</Link></span> : <></>}
                                <button
                                  className={`btn btn-sm rounded-pill ${uiCampaign.is_mapped ? 'btn-danger' : 'btn-primary'}`}
                                  onClick={() => { setSelectedUiCampaign(uiCampaign); setLinkActionConfirmModal(true); }}
                                  style={{ width: '70px' }}
                                  disabled={loading.linkAction || (uiCampaigns.some(campaign => campaign.is_mapped === 1) && uiCampaign.is_mapped === 0)}
                                >
                                  {uiCampaign.is_mapped ? 'Unlink' : 'Link'}
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p>No UI campaigns available. <span ><Link to="/client/campaigns" style={{ textDecoration: 'none' }}>Create Campaign</Link></span></p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      <ConfirmModal
        show={linkActionConfirmModal}
        loadingOnsubmit={loading.linkAction}
        onClose={() => setLinkActionConfirmModal(false)}
        onSubmit={handleLinkOrUnlinkUICampaign}
        title={selectedUiCampaign?.is_mapped ? 'Unlink UI Campaign' : 'Link UI Campaign'}
        body={
          selectedUiCampaign?.is_mapped
            ? 'Are you sure you want to unlink this UI campaign from the selected campaign?'
            : 'Are you sure you want to link this UI campaign to the selected campaign?'
        }
      />
    </div>
  );
};

export default LinkCampaigns;
